export const state = {
  dataTable: [],
  teamtaskDetail: [],
  assignee: null
}

export const mutations = {
  SET_DATA_TABLE(state, payload) {
    state.dataTable = payload
  },
  SET_TEAMTASK_DETAIL(state, payload) {
    state.teamtaskDetail = payload
  },
  SET_TEAMTASK_ASSIGNEE(state, payload) {
    state.assignee = payload
  }
}

export const actions = {
  setDataTable({ commit }, payload) {
    commit('SET_DATA_TABLE', payload)
  },
  setTeamtaskDetail({ commit }, payload) {
    commit('SET_TEAMTASK_DETAIL', payload)
  },
  setTeamTaskAssignee({ commit }, payload) {
    commit('SET_TEAMTASK_ASSIGNEE', payload)
  }
}
